import React from "react";
import Footer from "../components/common/Footer";
import ServicesPage from "../components/core/ServicesPage";

const Services = () => {
	return (
		<div>
			<ServicesPage />
			<Footer />
		</div>
	);
};

export default Services;
